module.exports = __webpack_public_path__ + "static/media/footer_equipbid_icon.bfa249db.png";